import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import content, { contentPropTypes } from './RatesErrorSection.content';
import withContent from '../../../../containers/withContent';
import { treasuryNumber } from '../../../../config/ift';

export const RatesErrorSection = ({
	content: { header = '', description, enquiryDescription = '', checkBoxDescription } = {},
}) => {
	const enquiryDescriptionWithPhoneNumber = enquiryDescription.replace('{contactNumber}', treasuryNumber);
	return (
		<HighlightTile type="info">
			<div>
				<b>{header}</b>
				<p>{description}</p>
				{enquiryDescriptionWithPhoneNumber && <p>{enquiryDescriptionWithPhoneNumber}</p>}
				{checkBoxDescription && <p>{checkBoxDescription}</p>}
			</div>
		</HighlightTile>
	);
};

RatesErrorSection.propTypes = {
	content: PropTypes.shape(contentPropTypes),
};
export default compose(withContent({ content }))(RatesErrorSection);
